var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeWork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29604_106262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1659 12.5002H15.8326V14.1668H14.1659V12.5002ZM14.1659 9.16683H15.8326V10.8335H14.1659V9.16683ZM14.1659 5.8335H15.8326V7.50016H14.1659V5.8335ZM11.4492 5.8335L12.4992 6.5335V5.8335H11.4492Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33203 2.5V3.75833L9.9987 4.86667V4.16667H17.4987V15.8333H14.1654V17.5H19.1654V2.5H8.33203Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.80703 4.75L12.4987 8.54167V17.5H0.832031V8.73333L6.80703 4.75ZM8.33203 15.8333H10.832V9.3L6.80703 6.74167L2.4987 9.48333V15.8333H4.9987V10.8333H8.33203V15.8333Z",
    fill: "#475467"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29604_106262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWork);
export default __webpack_public_path__ + "static/media/home-work.7c8ea91878c48cbbcf1fccc6a193186f.svg";
export { ForwardRef as ReactComponent };